import { c as _c } from "react/compiler-runtime";
import { Button, Tooltip, ActionIcon, Popover } from '@mantine/core';
import { RichText } from 'components/form/RichText';
import { IconType } from 'react-icons';
import { HiPlusCircle, HiExclamation, HiQuestionMarkCircle } from 'react-icons/hi';
import { isNullOrEmpty, notNullOrEmpty } from 'shared/collection';
import { mapEntries } from 'shared/collection';
import { NotNull } from 'shared/type';
import { colors } from 'components/theme/theme';
import { CommentStatusSummary } from './comments';
import { CommentStatus } from './commentTypes';
import { isEmpty } from 'remeda';
export const StatusButton = t0 => {
  const $ = _c(8);
  const {
    values,
    setStatus
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Popover.Target><Tooltip label="Select a status" withinPortal={true}><ActionIcon><HiPlusCircle {...itemIconProps} /></ActionIcon></Tooltip></Popover.Target>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== setStatus || $[2] !== values) {
    let t3;
    if ($[4] !== values) {
      t3 = s => ({
        ...s,
        selected: values.includes(s.value)
      });
      $[4] = values;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = statusItemsFlat.map(t3).map(t4 => {
      const {
        label,
        value,
        selected
      } = t4;
      return <Button key={value} leftSection={<CommentStatusIcon {...statusIconProps(value)} />} styles={{
        inner: {
          justifyContent: "flex-start"
        }
      }} data-selected={selected} onClick={() => {
        setStatus(selected ? values.filter(v => v != value) : [...values, value]);
      }}>{label}</Button>;
    });
    $[1] = setStatus;
    $[2] = values;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <Popover closeOnEscape={true} closeOnClickOutside={true} withinPortal={true}>{t1}<Popover.Dropdown><div className="flex flex-col space-y-2">{t2}</div></Popover.Dropdown></Popover>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export const statusIconProps = (value: StatusType) => statusItems[value];
export const CommentStatuses = t0 => {
  const $ = _c(2);
  const {
    statusSummary
  } = t0;
  let t1;
  if ($[0] !== statusSummary) {
    t1 = isEmpty(statusSummary) ? <></> : <div className="flex items-center gap-0">{mapEntries(statusSummary, _temp)}</div>;
    $[0] = statusSummary;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const CommentStatusIcon = t0 => {
  const $ = _c(15);
  let {
    Icon,
    color,
    label,
    resolved,
    statusSummary
  } = t0;
  const justIcon = statusSummary == null;
  let t1;
  if ($[0] !== resolved || $[1] !== statusSummary?.resolved || $[2] !== statusSummary?.unresolved) {
    t1 = resolved ?? (notNullOrEmpty(statusSummary?.resolved) && isNullOrEmpty(statusSummary?.unresolved));
    $[0] = resolved;
    $[1] = statusSummary?.resolved;
    $[2] = statusSummary?.unresolved;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  resolved = t1;
  let t2;
  if ($[4] !== justIcon || $[5] !== label || $[6] !== resolved || $[7] !== statusSummary) {
    t2 = justIcon ? `${label}${resolved ? " (resolved)" : ""}` : <><h4>{label}</h4><div className="flex flex-col divide-y divide-gray-700">{statusSummary.unresolved?.map(_temp2)}</div></>;
    $[4] = justIcon;
    $[5] = label;
    $[6] = resolved;
    $[7] = statusSummary;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = resolved ? colors.gray[2] : color ?? itemIconProps.color;
  let t4;
  if ($[9] !== Icon || $[10] !== t3) {
    t4 = <div><Icon {...itemIconProps} color={t3} /></div>;
    $[9] = Icon;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t4) {
    t5 = <Tooltip withinPortal={true} label={t2}>{t4}</Tooltip>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
const statusItems: Record<CommentStatus, StatusItemProps> = {
  'issue-critical': {
    label: 'Critical Issue',
    Icon: HiExclamation,
    color: colors.red![5]!
  },
  'issue-minor': {
    label: 'Minor Issue',
    Icon: HiExclamation,
    color: colors.amber![5]!
  },
  question: {
    label: 'Question',
    Icon: HiQuestionMarkCircle,
    color: colors.blue![5]!
  }
};
const statusItemsFlat = mapEntries(statusItems, (value, cfg) => ({
  value,
  ...cfg
}) as StatusItemProps & {
  value: StatusType;
});
const itemIconProps = {
  size: 20,
  color: colors.gray[5]
};
export type StatusType = keyof typeof statusItems;
export type StatusItemProps = {
  label: string;
  Icon: IconType;
  color?: string;
};
function _temp(status, items) {
  return <CommentStatusIcon key={status} {...statusIconProps(status)} statusSummary={items} />;
}
function _temp2(t, i) {
  return <RichText key={i} readonly={true} value={t} className="py-2" />;
}